<template>
  <div class="card">
    <div class="card-body">
      <div class="d-flex with-button">
        <div class="p-2">
          <h1>권한 관리</h1>
        </div>
        <div class="p-2 small bottom">
          총 <strong><span class="number mint">{{tableData.length}}</span></strong> 건
        </div>

        <div class="ml-auto p-2">
          <button type="button" class="btn mint" @click="register">권한 저장</button>
        </div>

      </div>

      <!-- <div class="input-group search">
        <div class="input-group-prepend">
          <span class="input-group-text"><i class="fas fa-search"></i></span>
        </div>
        <input type="text" class="form-control" aria-describedby="basic-addon1" v-model="search.menu_name" @keyup.enter="retrieve" />
        <div class="input-group-apend">
          <button type="button" class="btn btn-default" @click="retrieve">
             검색
          </button>
        </div>
      </div> -->

      <!-- <div>
        <a href="#" class="arrowdown">arrow down</a>
      </div> -->

    </div>

    <el-row>
      <el-col :span="11">
        <!-- 그리드 -->
        <stone-data-table
          table-ref="authGrpTable"
          :loading="searchLoading"
          :columns="authGrpTableColumns"
          :data="authGrpTableData"
          :table-props="tableProps"
          :current-row="currentRow"
          :page-size="emptyPageSize"
          :pagination-props="emptyPaginationProps"
          @row-click="rowClickHandlerAuthGrp">
        </stone-data-table>
      </el-col>
      <el-col :span="1">&nbsp;</el-col>
      <el-col :span="12">
        <!-- 그리드 -->
        <el-tree
          :data="tableData"
          ref="tree"
          show-checkbox
          node-key="value"
          default-expand-all
          :default-checked-keys="menuAuthData"
          :expand-on-click-node="false">
        </el-tree>
      </el-col>
    </el-row>

  </div>
</template>

<script>

import common from '@/modules/common'

export default {
  name: 'M990101',
  mixins: [common.mixins],
  data () {
    return {
      authGrpTableData: [],
      authGrpTableColumns: [
        {label: '권한명', prop: 'code_name', align: 'left'}
      ],
      currentRow: null,
      tableData: [],
      menuAuthData: [],
      tableColumns: [
        {label: '메뉴코드', prop: 'menu_code', align: 'left', class: 'bold', width: 100},
        {label: '메뉴명', prop: 'menu_name', align: 'left', width: 200},
        {label: '메뉴 유형', prop: 'menu_type_name', width: 100},
        {label: '상위 메뉴', prop: 'parent_name', width: 100},
        {label: '클래스명', prop: 'class_name', align: 'left', width: 150},
        {label: '정렬', prop: 'ordby', align: 'right', width: 60}
      ],
      tableProps: {height: this.getScreenHeight(-98), highlightCurrentRow: true},
      actionColDef: {
        label: '삭제',
        tableColProps: {
          align: 'center'
        },
        def: [{
          handler: row => {
            this.deleteMenu(row.menu_code, row.parent_code)
          },
          buttonProps: {
            type: 'danger',
            size: 'mini',
            icon: 'el-icon-delete'
          },
          name: '삭제'
        }]
      },
      search: {
        menu_name: ''
      }
    }
  },
  beforeCreate () {
  },
  created () {
    if (this.$route.params.isSearch) {
      this.$parent.$parent.getMenuAuth()
    }
    this.retreiveAuthGrp()
  },
  mounted () {
  },
  methods: {
    retreiveAuthGrp () {
      let apiUrl = '/code/AUTH_GRP/child'
      if (this.$store.getters.auth_grp !== 'SYS') {
        apiUrl += '/A'
      }
      common.axios.get(apiUrl)
        .then(response => {
          // console.log(response.data)
          this.authGrpTableData = response.data
          this.$nextTick(() => {
            this.currentRow = this.authGrpTableData[0]
            this.retrieve(this.currentRow.code_id)
          })
        })
    },
    retrieve (authGrp) {
      common.axios.get('/auth/' + authGrp)
        .then(response => {
          this.tableData = response.data
          // console.log(this.tableData)
          this.menuAuthData = []
          this.tableData.forEach(x => {
            if (x.data === 'Y') {
              this.menuAuthData.push(x.value)
            }
            if (x.children) {
              x.children.forEach(z => {
                if (z.data === 'Y') {
                  this.menuAuthData.push(z.value)
                }
              })
            }
          })
        })
    },
    rowClickHandlerAuthGrp (row, event, column) {
      this.currentRow = row
      this.retrieve(this.currentRow.code_id)
    },
    register () {
      const checkedData = this.$refs.tree.getCheckedKeys()
      const menuAuth = []
      checkedData.forEach(x => {
        menuAuth.push({menu_code: x})
      })
      common.axios.post('/auth/storage', {auth_grp: this.currentRow.code_id, menu_auth: menuAuth})
        .then(response => {
          if (response.data.status === 1) {
            this.$message('저장되었습니다.')
          }
        })
    }
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>

</style>



// WEBPACK FOOTER //
// src/pages/M990301.vue